export interface SpecialtyMoreInfo {
  title: string;
  description: string;
}

export interface Specialty {
  id?: string;
  nameLong: string;
  nameShort: string;
  moreInfo: SpecialtyMoreInfo;
}

export enum TelebehavioralHealthSpecialties {
  P = 'P',
  PS = 'PS',
  PSY = 'PSY',
  NPFAMPSYMH = 'NPFAMPSYMH'
}

export enum VirtualPrimaryCareSpecialties {
  TBD = 'TBD'
}
